import React, { useState, useEffect } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  FormLabel,
  Input,
  FormErrorMessage,
  useDisclosure,
  Box,
  Divider,
  Image,
  ChakraProvider,
} from "@chakra-ui/react";
import {
  GetCategoriesList,
  SearchCategoryService,
  UpdateCategoryService,
} from "../../service/service"; // Assume this is the API call
import Swal from "sweetalert2";
import { MdOutlineEdit } from "react-icons/md";

function UpdateCategoryModal({
  setResponseData,
  setTotalPages,
  categoryData,
  currentPage,
  itemsPerPage,
  searchText
}) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isLoading, setIsLoading] = useState(false);
  const [imagePreview, setImagePreview] = useState(categoryData.image ? `${process.env.REACT_APP_IMG_API}/${categoryData.image}` : null);

  const [formData, setFormData] = useState({
    name: categoryData.category,
    file: null,
  });
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isOpen) {
      setFormData({ name: categoryData.category, file: null });
      setImagePreview(categoryData.image ? `${process.env.REACT_APP_IMG_API}/${categoryData.image}` : null);
    }
  }, [isOpen, categoryData]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === "file" && files.length > 0) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
      setImagePreview(URL.createObjectURL(files[0]));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const validate = () => {
    const errors = {};
    if (!formData.name) {
      errors.name = "Category name is required.";
    }
    if (!formData.file && !categoryData.image) {
      errors.file = "Image is required.";
    }
    return errors;
  };

  const handleSubmit = () => {
    const validationErrors = validate();
    if (Object.keys(validationErrors).length === 0) {
      try {
        setIsLoading(true);
        const formDataPayload = new FormData();
        formDataPayload.append("id", categoryData.id);
        formDataPayload.append("category_name", formData.name);
        if (formData.file) {
          formDataPayload.append("image", formData.file);
        }

        UpdateCategoryService(formDataPayload).then((result) => {
          if (result.status) {
            SearchCategoryService({
              searchText,
              per_page: itemsPerPage,
              page: currentPage + 1,
            })
              .then((result) => {
                setIsLoading(false);
                if (result.status) {
                  setResponseData(result.data.data);
                  setTotalPages(result.data.last_page);
                } else {
                  Swal.fire({
                    title: "Error!",
                    text: result.message,
                    icon: "error",
                    timer: 3000,
                    confirmButtonText: "OK",
                  });
                }
              })
              .catch((error) => {
                setIsLoading(false);
                console.log(error.message);
                Swal.fire({
                  title: "Error!",
                  text: error.message,
                  icon: "error",
                  timer: 3000,
                  confirmButtonText: "OK",
                });
              });

            onClose();
            setIsLoading(false);
            Swal.fire({
              icon: "success",
              title: "Category Updated Successfully!",
              showConfirmButton: false,
              timer: 1500,
            });
          } else {
            setIsLoading(false);
            Swal.fire({
              title: "Error!",
              text: result.message,
              icon: "error",
              timer: 3000,
              confirmButtonText: "OK",
            });
          }
        });
      } catch (error) {
        setIsLoading(false);
        Swal.fire({
          title: "Error!",
          text: error.message,
          icon: "error",
          timer: 3000,
          confirmButtonText: "OK",
        });
      }
    } else {
      setErrors(validationErrors);
    }
  };

  return (
    <ChakraProvider>
      <MdOutlineEdit fontSize={20} color="teal" onClick={onOpen} />
      <Modal isCentered isOpen={isOpen} onClose={onClose} size="xl">
        <ModalOverlay />
        <ModalContent>
          <ModalHeader color="#4D5454">Update Category</ModalHeader>
          <Divider />
          <ModalCloseButton />
          <ModalBody display="flex" flexDirection="column">
            <Box flex="1" pr="5">
              <FormControl isRequired isInvalid={errors.name}>
                <FormLabel>Category</FormLabel>
                <Input
                  placeholder="Enter category name here"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <FormErrorMessage>{errors.name}</FormErrorMessage>
                )}
              </FormControl>
              <FormControl isRequired mt="4" isInvalid={errors.file}>
                <FormLabel>Image</FormLabel>
                <Input
                  type="file"
                  name="file"
                  accept="image/*"
                  onChange={handleChange}
                  style={{ display: "none" }}
                  id="fileInput"
                />
                <label htmlFor="fileInput">
                  <Box
                    borderWidth="1px"
                    borderRadius="md"
                    p="2"
                    cursor="pointer"
                    textAlign={'center'}
                    borderColor={errors.file ? "red.500" : "gray.200"}
                  >
                    {formData.file ? formData.file.name : "Choose Image"}
                  </Box>
                </label>
                {errors.file && (
                  <FormErrorMessage>{errors.file}</FormErrorMessage>
                )}
              </FormControl>
              {imagePreview && (
                <Image
                  src={imagePreview}
                  alt={categoryData.category}
                  boxSize="200px"
                  mt="4"
                />
              )}
            </Box>
          </ModalBody>
          <ModalFooter>
            <Button colorScheme="gray" mr="3" onClick={onClose}>
              Close
            </Button>
            <Button
              isLoading={isLoading}
              colorScheme="teal"
              onClick={handleSubmit}
            >
              Save
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </ChakraProvider>
  );
}

export default UpdateCategoryModal;
